/* Notificaciones del usuario, llamado desde en encabezado del sitio, abre en ventana  */

//*react- recursos
  import React, { Component } from 'react';
  import { useEffect, useState } from "react";
  
  import Row from "react-bootstrap/Row";
  import Col from "react-bootstrap/Col";
  import Container from "react-bootstrap/Container";

//*componentes-utiles
  import CargandoSpin from "../../../componentes/CargandoSpin";
  import swal2 from "sweetalert2"; //npm install --save sweetalert2

//*clases 
  import { BsChevronDown, BsFillCircleFill, BsFillTrash3Fill } from "react-icons/bs";
  import "./encabezado.css";

//*api's (servicios y store)
  import notificationsStore from "../../../api/recursos/notifications/notifications.store";
  import notificationsService from "../../../api/recursos/notifications/notifications.servicio";
  
//*datos
  import etiquetasSSC from "../../../datos/json/etiquetasSSC.json";  


//* interface (parametros de entrada)
  interface PropsNotificaciones {
    tokenStore: any;
  }

//*componente
  export default function Notificaciones(props: PropsNotificaciones) {

    //*api store
      const { guardaGetSummarybyUserStore,
              notAvisosStore, notPendientesStore,
              activaDesactivaNotAvisosStore,
              activaDesactivaTodosNotAvisosStore,
              notTotalAvisosStore, notTotalPendienteStore,
              guardaDeleteNoticebyUserStore,
              generaObjErrorNotificationsStore } = 
        notificationsStore((state: any) => ({
              guardaGetSummarybyUserStore: state.guardaGetSummarybyUserStore,
              notAvisosStore: state.notAvisosStore,
              notPendientesStore: state.notPendientesStore,
              activaDesactivaNotAvisosStore: state.activaDesactivaNotAvisosStore,
              activaDesactivaTodosNotAvisosStore: state.activaDesactivaTodosNotAvisosStore,
              notTotalAvisosStore: state.notTotalAvisosStore,
              notTotalPendienteStore:state.notTotalPendienteStore,
              guardaDeleteNoticebyUserStore: state.guardaDeleteNoticebyUserStore,
              generaObjErrorNotificationsStore: state.generaObjErrorNotificationsStore,
      }));

    //*store's
    //*datos
    //*constantes y variables

      const [swRecarga, setSwRecarga] =  useState(false);
      const [cargandoSpin, setCargandoSpin] = useState(false);
      const [swRecargaNotificaciones, setSwRecargaNotificaciones] =  useState(false);

      const [swCargaNotificaciones, setSwCargaNotificaciones] =  useState(false);
      const [swRecargaAvisos, setSwRecargaAvisos] =  useState(false);
      const [swRecargaPendientes, setSwRecargaPendientes] =  useState(false);

      const [seleccionarTodos, setSeleccionarTodos] =  useState(false);

      const [notAvisosFront,  setNotAvisosFront] =  useState([]);
      const [notPendientesFront,  setNotPendientesFront] =  useState([]);
      const [totalAvisos,  setTotalAvisos] =  useState(0);
      const [totalPendientes,  setTotalPendientes] =  useState(0);
      const [isChecked, setIsChecked] = useState(false);

    //*useEffect
      useEffect(()=> {  //llamada al API - Notifications/GetSummarybyUser 
        setCargandoSpin(true);
        notificationsService.cargaGetSummarybyUser(props.tokenStore)
          .then(function(response:any){
              //console.log('::response.................',response)
              if (response.status==200) {  //confirma que no hay error
                  guardaGetSummarybyUserStore(response.data).then( function(datos:any) { 
                    //console.log('cargo los datos a las stores');
                  })
              }
              setSwRecargaAvisos(!swRecargaAvisos);
              setSwRecargaPendientes(!swRecargaPendientes)
              setCargandoSpin(false);
          })
          .catch((ex) => {
              console.log ("--catch - ex (cargaGetSummarybyUser): ", ex);
              if (ex.response.status==404) //no es error solo no tiene información
                  console.log('nota: no es error solo no tiene información')
              else
                  generaObjErrorNotificationsStore(ex.response, true, '', '', 'Notificaciones','E')
              setCargandoSpin(false);
          })
      }, [swCargaNotificaciones]);

      useEffect(()=> {  //cambios a las variables del front (recarga)
         //console.log('******entro PENDIENTES*****')
         setNotPendientesFront(notPendientesStore);
        
         setTotalPendientes(notPendientesStore.length);
       }, [swRecargaPendientes]);  

       useEffect(()=> {  //cambios a las variables del front (recarga)
        //console.log('******entro setNotAvisosFront(notAvisosStore); Actualiza avisos front*****')
        setNotAvisosFront(notAvisosStore);
        setTotalAvisos(notAvisosStore.length);        
      }, [swRecargaAvisos]);       

      useEffect(()=> {
        setSwRecargaNotificaciones(!swRecargaNotificaciones)
      }, [swRecarga]);     

    //*funciones

      //muestra u oculta las noticias de los avisos
      const toggle1 = (key: any) => {     
        const myElement: HTMLElement | null = document.getElementById(key)!;     
        myElement.classList.toggle("notice" ? "mostrar" : "ocultar");
      };  

      const [toggle, setToggle] = useState(true);

      const handleClick = () => { setToggle(!toggle) };
      
      const handleTab1 = () => { setActiveTab("pendientes") };

      const handleTab2 = () => {  setActiveTab("avisos") };
    
      //convierte la fecha de la bd al formato año, mes y dia
      function fecha(date: any) {        
        const fecha = new Date(date);
        const dia = fecha.getDate();
        const mes = fecha.getMonth() + 1; //se le suma 1, porque enero empieza en 0
        const anio = fecha.getFullYear();      
        // console.log(dia, mes, anio);
        return anio + "/" + mes + "/" + dia;
      }

      //pestañas, activa la pestaña seleccionada Pendientes/Aviso
      const [activeTab, setActiveTab] = useState("pendientes");

      const AbrirT = () => {   
        notAvisosStore?.map((data: any, key: any) => {   
          const list = document.getElementById(data.idnews)?.classList;
          list?.add("mostrar"); 
        });
        notPendientesStore?.map((data: any, key: any) => {        
          const list = document.getElementById(data.idnews)?.classList;
          list?.add("mostrar");
        });
      }

      const CerrarT = () => {   
        notAvisosStore?.map((data: any, key: any) => { 
          const list = document.getElementById(data.idnews)?.classList;          
          list?.remove("mostrar");
        });
        notPendientesStore?.map((data: any, key: any) => {        
          const list = document.getElementById(data.idnews)?.classList;
          list?.remove("mostrar");
        });      
      }


      const handleTab3 = () => {
        if (activeTab === "avisos") {
          notAvisosStore?.map((data: any, key: any) => {         
            toggle1(data.idnews);
          });
        } else {
          notPendientesStore?.map((data: any, key: any) => {        
            toggle1(data.idnews);
          });
        }
      };

      //checked
      //const [isChecked, setIsChecked] = useState(false);
      // const handleOnChange = () => {
      //   setIsChecked(!isChecked);
      // };
      const cambiaNotAvisosStore = (e: any) => {            
        let miCheckId = e.target.id;             
        let posP = miCheckId.indexOf('_');          
        let notAvisoId = miCheckId.substr( posP+1, miCheckId.length-posP );       

        activaDesactivaNotAvisosStore(notAvisoId);
        setTimeout(() => { setSwRecargaAvisos(!swRecargaAvisos) }, 200); // le damos tiempo para asegurar el proceso
        
        let aviso1:any = [];
        notAvisosStore?.map((data: any, key: any) => {
          aviso1.push(data.activo);//se guadar en un array      
        })
        //para el id=idSeleccionarTodo
        for (let valor of aviso1){
          if (!valor){//si es true
            setSeleccionarTodos(false);
            return
          }else{  
            setSeleccionarTodos(true);
          }  
        }            

    };


      const cambiaSeccionarTodos = (e: any) => {
        //let miCheckId = e.target.id; 
        //let elem = document.getElementById(miCheckId); 
        let elem = e.target.checked; 
        //console.log('elem.....', elem);
        if (elem)
            setSeleccionarTodos(true);
        else
            setSeleccionarTodos(false);
        
        activaDesactivaTodosNotAvisosStore(seleccionarTodos);
        setTimeout(() => { setSwRecargaAvisos(!swRecargaAvisos) }, 200); // le damos tiempo para asegurar el proceso
        //setSwRecarga(!swRecarga)
      };

      const eliminarAvisos = (e: any) => {
        let idEliminar:any = [];
        notAvisosStore?.map((data: any, key: any) => {   
          //console.log(data.activo, data.idnews);
          let id = data.idnews;
          if (data.activo)      
            idEliminar = [...idEliminar, id];

        })
        if (idEliminar.length === 0){
          swal2.fire({
            title: "Seleccionar uno o más avisos",
            confirmButtonText: "Cerrar",
            confirmButtonColor: '#3085d6',
          });
        }else{
        swal2.fire({
          title: '¿Seguro de eliminar el/los aviso(s)?',
          showDenyButton: true,
          confirmButtonText: 'Eliminar',
          denyButtonText: 'No eliminar',
        }).then((result) => {
          /* Read more about isConfirmed, isDenied below */
          if (result.isConfirmed) {
            setCargandoSpin(true);
              notificationsService.cargaDeleteNoticebyUser(props.tokenStore, idEliminar)
                .then(function(response:any){              
                    if (response.status==200) {  //confirma que no hay error
                        guardaDeleteNoticebyUserStore(response.data).then( function(datos:any) { 
                          //setTimeout(() => {setSwCargaNotificaciones(!swCargaNotificaciones) }, 500); // le damos tiempo para asegurar el proceso
                          setSwCargaNotificaciones(!swCargaNotificaciones);
                          setSeleccionarTodos(false); 
                          setSwRecarga(!swRecarga);
                        //console.log('*****catOrigenesFront: ', catOrigenesFront );
                      })
                    } 
                    setCargandoSpin(false);
                })
                .catch((ex) => {
                    console.log ("--catch - ex (cargaGetSummarybyUser): ", ex);
                    if (ex.response.status==404) //no es error solo no tiene información
                        console.log('nota: no es error solo no tiene información')
                    else
                        generaObjErrorNotificationsStore(ex.response, true, '', '', 'Notificaciones','E')
                    setCargandoSpin(false);
                });
                swal2.fire({
                  title: "Aviso(s) eliminado(s)",
                  confirmButtonText: "Cerrar",
                  confirmButtonColor: '#3085d6',
                });
                setSwRecarga(!swRecarga)
          } else if (result.isDenied) {
              swal2.fire({
                title: "Aviso(s) no eliminado(s)",
                confirmButtonText: "Cerrar",
                confirmButtonColor: '#3085d6',
              });
          }
        })
      }
      };

    //*vista
      return (
        <>   
         <div className="z-index_999999">
           {/*  <p>xxxx1</p>
            <p>xxxx2</p>
            <p>xxxx3</p>
            <p>xxxx4</p>
            <p>xxxx5</p> */}
              <ul className="navNotificaciones background-color-gris3 padding-varios2">
                <li
                  id="tab1"
                  onClick={handleTab1}
                  className={activeTab === "pendientes" ? "activeT " : ""}
                >
                  {etiquetasSSC.Notificaciones.etiquetas[3].text} ({notTotalPendienteStore})           
                </li>
                <li
                  id="tab2"
                  onClick={handleTab2}
                  className={activeTab === "avisos" ? "activeT " : ""}
                >
                  {etiquetasSSC.Notificaciones.etiquetas[4].text}({notTotalAvisosStore})
                </li>

                <li
                  onClick={AbrirT}
                  className="cursorHand abrirC"            
                  title='Abrir todas las notificaciones'
                >
                  Abrir todo
                </li>
                <li
                  onClick={CerrarT}
                  className="cursorHand abrirC"            
                  title='Cerrar todas las notificaciones'
                >
                Cerrar todo
                </li>
                
              </ul>
              <br/>
              <div className="outlet">
                {activeTab === "pendientes" 
                  ? ( 
                    <>
                      <div>{etiquetasSSC.Notificaciones.etiquetas[3].text}</div>
                      <div id="divScrollNotify1">
                        <div className="row px-3 pt-0 pl-0 ng-hide">
                          <div className="col-sm-12 background-colorBlue6 padding2 pl-0 ">
                            <div className="row pt-0 pb-0 pl-4">
                              <div className="col-sm-12 px-0 ">
                                <br />
                                {notPendientesStore?.map((data: any, key: any) => {
                                  return (
                                    <>
                                      <div className="row formato">
                                        <div className="col-sm-4">
                                          <li>
                                            <BsFillCircleFill size={5} />
                                            {"   "}
                                            {fecha(data.createdat)}
                                          </li>
                                        </div>
                                        <div className="col-sm-8" id="inotice">
                                          <li onClick={() => toggle1(data.idnews)}>
                                            {data.descripcion}
                                            <span className="ico">
                                              <BsChevronDown />
                                            </span>
                                          </li>
                                        </div>
                                      </div>
                                      <div className="lip">
                                        <p className="notice ocultar " id={data.idnews}>
                                          {data.notice}
                                        </p>
                                      </div>
                                    </>
                                  );
                                })}
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </> 
                    ) 
                  : ( 
                    <>
                      <div>{etiquetasSSC.Notificaciones.etiquetas[4].text}</div>
                                    
                      <div id="divScrollNotify2"  >
                      {/*  <div className="row px-3 pt-0 pl-0 ng-hide "> */}
                            <div className="container">    
                              <div className="row letra">
                                  
                                    <div className="letra">
                                      <Container fluid >
                                        <Row className = "anchoBandaAvisos" >
                                          <Col xs={6} >
                                            <div className="divAnchoAvisos">
                                            <input 
                                              id="idSeleccionarTodo" 
                                              type="checkbox" 
                                              checked={seleccionarTodos}
                                              onChange={cambiaSeccionarTodos}                            
                                            /></div>
                                          <div style={{display:"inline-block"}}>{etiquetasSSC.Notificaciones.etiquetas[8].text}   </div>
                                          </Col>
                                          <Col xs={6}  onClick={eliminarAvisos} className="cursorHand text-decoration-none" title="Elimina avisos seleccionados">                            
                                            <BsFillTrash3Fill /> {etiquetasSSC.Notificaciones.etiquetas[9].text} 
                                          </Col>
                                        </Row>
                                      </Container>
                                    </div>
                                  
                              </div>                 
                              <br />
                              {notAvisosStore?.map((data: any, key: any) => {
                                return (
                                  <>
                                    <div className="row formato">
                                      <div className="col-sm-3">
                                        <div className="claseCK">
                                          <input
                                            type="checkbox"
                                            key={`input_${data.idnews}`}
                                            id={`input_${data.idnews}`} 
                                            checked={data.activo}
                                            onChange={cambiaNotAvisosStore}
                                          />
                                        </div>
                                        <div id={`div2_${data.idnews}`} className="claseCKTexto padding-07r noBR">
                                          {" "}
                                          {fecha(data.createdat)}
                                        </div>
                                      </div>
                                      <div className="col-sm-7" id="inotice">
                                        <li onClick={() => toggle1(data.idnews)}>
                                          {data.descripcion}
                                          <span className="ico">
                                            <BsChevronDown />
                                          </span>
                                        </li>
                                      </div>
                                    </div>
                                    <div className="lip">
                                      <p className="notice ocultar " id={data.idnews}>
                                        {data.notice}
                                      </p>
                                    </div>
                                  </>
                                );
                              })}                       
                          </div>
                      {/* </div> */}
                    </div>
                    </>
                  )
                }
              </div>

              {/* ventana de carga con spin que se abre mientras lee el api */}
              { cargandoSpin ? <CargandoSpin /> : null }
          </div>
        </>
      );
  }
